export const environment = {
  production: false,
  /** Base URL del microservicio api-comunicaciones (incluye el prefijo /api). */
  apiUrl: 'https://api.dev.communications.ucc.edu.ar/api',
};
